export default "__VITE_ASSET__CVIlUmJO__"